<template>
  <div class="w-100 rounded-5">
    <div class="question-accordion-section rounded-5 w-100 overflow-hidden">
      <!-- MAXIM STYLING -->

      <!-- CREATE NEW QUESTION -->
      <div class="maxim w-100" v-if="action == 'create'">
        <!-- TOP -->
        <div class="top">
          <!-- SELECTION ROW -->
          <div
            class="selection-row d-flex justify-content-start align-items-center flex-wrap"
          >
            <!-- QUESTION TYPE -->
            <div class="selection-input">
              <div class="key">Type</div>
              <div class="line"></div>
              <select
                class="form-control select-md-box"
                v-model="new_question.option_type"
              >
                <option value="true_false">True / False</option>
                <option value="multichoice">Multiple Choice</option>
                <option value="short_answer" v-if="false">Blank</option>
                <option value="essay" v-if="false">Essay</option>
              </select>
              <div class="icon-caret-down border_grey_dark font-11"></div>
            </div>
            <!-- QUESTION TYPE -->

            <!-- QUESTION DIFFICULTY -->
            <div class="selection-input">
              <div class="key d-none d-md-block">Difficulty</div>
              <div class="key d-md-none">Level</div>
              <div class="line"></div>
              <select
                class="form-control select-sm-box"
                v-model="new_question.difficulty"
              >
                <option value="easy">Easy</option>
                <option value="medium">Medium</option>
                <option value="hard">Hard</option>
              </select>
              <div class="icon-caret-down border_grey_dark font-11"></div>
            </div>
            <!-- QUESTION DIFFICULTY -->

            <!-- QUESTION SCORE -->
            <div class="selection-input" v-if="false">
              <div class="key">Score</div>
              <div class="line"></div>
              <input
                type="number"
                min="0"
                length="3"
                v-model="new_question.score"
                class="form-control number-box"
                placeholder="100"
              />
            </div>
            <!-- QUESTION SCORE -->

            <!-- QUESTION DURATION -->
            <div class="selection-input">
              <div class="key">
                Duration
                <span
                  class="hint--primary hint--bottom hint--medium hint--rounded"
                  aria-label="Duration in seconds"
                >
                  <i class="icon-info font-11 brand_green pointer"></i>
                </span>
              </div>
              <div class="line"></div>
              <input
                type="number"
                min="0"
                length="3"
                v-model="new_question.duration"
                class="form-control number-box"
                placeholder="50"
                required
              />
            </div>
            <!-- QUESTION DURATION -->
          </div>

          <!-- QUESTION ENTRY -->
          <div class="question-entry">
            <div
              class="title-text text-uppercase color_grey_dark font-weight-bold"
            >
              Question Text <span class="brand_tonic">*</span>
            </div>
            <!-- <TextEditor :basic="basic_type"  :placeholder="new_question.question || 'Enter your question'" @questionInput="questionInput"  ></TextEditor> -->
            <TextEditor
              event_name="input_question"
              @input_question="questionInput($event)"
              :content="new_question.question"
            />
          </div>
          <!-- QUESTION ENTRY -->

          <!-- OPTIONS BLOCK -->
          <OptionsBlock
            v-if="new_question.option_type == 'true_false'"
            option_type="true_false"
            :clear="clear_options"
            @setAnswer="getAnswer"
          />

          <OptionsBlock
            v-else-if="
              new_question.option_type == 'multiple' ||
                new_question.option_type == 'multichoice'
            "
            :option_type="new_question.option_type"
            @setAnswer="getAnswer"
            @getAnswer="getAnswerContent"
          />
          <!-- OPTIONS BLOCK -->

          <!-- SELECT TOPIC CTA -->
          <div
            class="topic-cta rounded-5 pointer"
            @click="$emit('closeTriggered')"
            v-if="false"
          >
            <div class="icon-plus font-18 color_ash"></div>
            <div class="text color_ash">
              <span class="font-weight-bold text-uppercase">Assign topic</span>
              (Required)
            </div>
          </div>

          <SearchSelect
            @topicSelected="updateTopic($event)"
            :clear="clear_selection"
          />

          <!-- RESET BUTTON -->
          <button
            class="btn btn-sm btn-accent brand_navy font-10-5 mx-0 clear-btn"
            v-if="new_question.topic_id"
            @click="emptyTopicSelection"
          >
            Reset selection
          </button>

          <!-- SELECT TOPIC CTA -->

          <!-- TOPIC HOLDER -->
          <div
            class="topic-row d-flex justify-content-start align-items-start flex-wrap"
          >
            <div
              class="topic-holder d-flex justify-content-center align-items-center nowrap brand_inverse_light_bg rounded-40"
              v-for="(topic, index) in selected_topics"
              :key="index"
            >
              <div class="text brand_navy">{{ topic.topic }}</div>
              <div class="avatar pointer white" @click="removeTopic(index)">
                <span class="icon-minus brand_tonic font-18 flex-center"></span>
              </div>
            </div>
          </div>
          <!-- TOPIC HOLDER -->

          <!-- IMAGE SECTION -->
          <div
            class="image-section rounded-5 position-relative"
            v-if="question_image"
          >
            <!-- CLOSE DIALOG -->
            <div
              class="avatar brand_navy_bg position-absolute pointer"
              @click="emptyImage"
            >
              <span class="icon-decline font-13 color_white flex-center"></span>
            </div>
            <!-- IMAGE SELECTED -->
            <img v-lazy="question_image" alt />
          </div>
          <!-- IMAGE SECTION -->
        </div>
        <!-- TOP -->

        <!-- BOTTOM -->
        <div class="bottom">
          <!-- ATTACHMENT -->
          <div class="button-left w-auto pointer px-1">
            <label for="attachImage" class="attachment pointer">
              <div
                class="attach icon icon-insert-image font-20 border_grey_dark mr-2"
              ></div>
              <div class="attach text font-14 brand_navy mt-1">
                <input
                  type="file"
                  id="attachImage"
                  accept=".png, .jpg, .jpeg"
                  hidden
                  @change="uploadImage"
                />
                Attach Image
              </div>
            </label>
          </div>

          <!-- SAVE BUTTON -->
          <div class="button-right">
            <!-- THRASH -->
            <div
              @click="clearQuestionContent"
              class="delete icon-thrash border_grey_dark font-22 pointer"
            ></div>
            <!-- SEPERATOR LINE -->
            <div class="seperator-line"></div>
            <!-- BUTTON -->
            <button
              @click="createNewQuestionData"
              ref="createQuestionBtn"
              :disabled="isDisabled || isCreating"
              class="btn btn-sm font-10 px-3 btn-accent brand_navy"
            >
              <div
                v-if="isCreating"
                class="icon-dotted-roller font-17 mr-2 animate"
              ></div>
              {{ isCreating ? "Creating.." : "Create" }}
            </button>
          </div>
        </div>
        <!-- BOTTOM -->
      </div>
      <!-- ====== CREATE NEW QUESTION -->

      <!-- ============================ MULTICHOICE QUESTIONS UPDATE QUESTION SECTION  =================================== -->
      <div class="maxim w-100" v-else-if="action === 'edit'">
        <!-- TOP -->
        <div class="top">
          <!-- SELECTION ROW -->
          <div
            class="selection-row d-flex justify-content-start align-items-center flex-wrap"
          >
            <!-- QUESTION TYPE -->
            <div class="selection-input">
              <div class="key">Type</div>
              <div class="line"></div>
              <select
                class="form-control select-md-box"
                v-model="update_question.option_type"
              >
                <option value="true_false">True / False</option>
                <option value="multichoice">Multiple Choice</option>
                <!-- <option value="short_answer">Blank</option>
                            <option value="essay">Essay</option> -->
              </select>
              <div class="icon-caret-down border_grey_dark font-11"></div>
            </div>
            <!-- QUESTION TYPE -->

            <!-- QUESTION DIFFICULTY -->
            <div class="selection-input">
              <div class="key d-none d-md-block">Difficulty</div>
              <div class="key d-md-none">Level</div>
              <div class="line"></div>
              <select
                class="form-control select-sm-box"
                v-model="update_question.difficulty"
              >
                <option value="easy">Easy</option>
                <option value="medium">Medium</option>
                <option value="hard">Hard</option>
              </select>
              <div class="icon-caret-down border_grey_dark font-11"></div>
            </div>
            <!-- QUESTION DIFFICULTY -->

            <!-- QUESTION SCORE -->
            <div class="selection-input" v-if="false">
              <div class="key">Score</div>
              <div class="line"></div>
              <input
                type="number"
                min="0"
                length="3"
                v-model="update_question.score"
                class="form-control number-box"
                placeholder="100"
              />
            </div>
            <!-- QUESTION SCORE -->

            <!-- QUESTION DURATION -->
            <div class="selection-input">
              <div class="key">
                Duration
                <span
                  class="hint--primary hint--bottom hint--medium hint--rounded"
                  aria-label="Duration in seconds"
                >
                  <i class="icon-info font-11 brand_green pointer"></i>
                </span>
              </div>
              <div class="line"></div>
              <input
                type="number"
                min="0"
                length="3"
                v-model="update_question.duration"
                class="form-control number-box"
                placeholder="50"
              />
            </div>
            <!-- QUESTION DURATION -->
          </div>

          <!-- QUESTION ENTRY -->
          <div class="question-entry">
            <div
              class="title-text text-uppercase color_grey_dark font-weight-bold"
            >
              Question Text
            </div>

            <TextEditor
              :action="'update'"
              :basic="basic_type"
              @questionInput="questionInput"
              :content="update_question.question"
              event_name="questionInput"
            ></TextEditor>
          </div>
          <!-- QUESTION ENTRY -->

          <!-- OPTIONS BLOCK -->
          <OptionsBlock
            :action="'update'"
            v-if="update_question.option_type == 'true_false'"
            :option_type="update_question.option_type"
            :option_bool_answer="Number(update_question.answer) ? true : false"
            :clear="clear_options"
            @setAnswer="getAnswer"
          ></OptionsBlock>

          <OptionsBlock
            :action="'update'"
            v-if="
              update_question.option_type == 'multiple' ||
                update_question.option_type == 'multichoice'
            "
            :option_type="update_question.option_type"
            @setAnswer="getAnswer"
            @getAnswer="getUpdateAnswerContent"
            :options_content="[
              {
                id: 'a',
                value: update_question.option_a,
                correct: update_question.answer.toLowerCase() === 'a',
              },
              {
                id: 'b',
                value: update_question.option_b,
                correct: update_question.answer.toLowerCase() === 'b',
              },
              {
                id: 'c',
                value: update_question.option_c,
                correct: update_question.answer.toLowerCase() === 'c',
              },
              {
                id: 'd',
                value: update_question.option_d,
                correct: update_question.answer.toLowerCase() === 'd',
              },
            ]"
          ></OptionsBlock>
          <!-- OPTIONS BLOCK -->

          <!-- SELECT TOPIC CTA -->
          <div
            class="topic-cta rounded-5 pointer"
            @click="$emit('closeTriggered')"
            v-if="false"
          >
            <div class="icon-plus font-18 color_ash"></div>
            <div class="text color_ash">
              <span class="font-weight-bold text-uppercase">Assign topic</span>
              (Required)
            </div>
          </div>

          <SearchSelect
            @topicSelected="updateTopic($event)"
            :editable="update_topic_data || {}"
            :clear="clear_selection"
          />
          <!-- SELECT TOPIC CTA -->

          <!-- TOPIC HOLDER -->
          <div
            class="topic-row d-flex justify-content-start align-items-start flex-wrap"
            v-if="false"
          >
            <div
              class="topic-holder d-flex justify-content-center align-items-center nowrap brand_inverse_light_bg rounded-40"
              v-for="(topic, index) in selected_topics"
              :key="index"
            >
              <div class="text brand_navy">{{ topic.topic }}</div>
              <div class="avatar pointer white" @click="removeTopic(index)">
                <span class="icon-minus brand_tonic font-18 flex-center"></span>
              </div>
            </div>
          </div>
          <!-- TOPIC HOLDER -->

          <!-- IMAGE SECTION -->
          <div
            class="image-section rounded-5 position-relative"
            v-if="question_image || update_question.image"
          >
            <!-- CLOSE DIALOG -->
            <div
              class="avatar brand_navy_bg position-absolute pointer"
              @click="emptyImage"
            >
              <span class="icon-decline font-13 color_white flex-center"></span>
            </div>

            <img
              v-if="update_question.image"
              v-lazy="update_question.image"
              alt
            />
            <img v-else v-lazy="question_image" alt />
          </div>
          <!-- IMAGE SECTION -->
        </div>
        <!-- TOP -->

        <!-- BOTTOM -->
        <div class="bottom">
          <!-- ATTACHMENT -->
          <div class="button-left w-auto pointer px-1">
            <label for="attachImage" class="attachment pointer">
              <div
                class="attach icon icon-insert-image font-20 border_grey_dark mr-2"
              ></div>
              <div class="attach text font-14 brand_navy mt-1">
                <input
                  type="file"
                  id="attachImage"
                  accept=".png, .jpg, .jpeg"
                  hidden
                  @change="uploadImage"
                />
                Attach Image
              </div>
            </label>
          </div>

          <!-- SAVE BUTTON -->
          <div class="button-right">
            <!-- THRASH -->
            <div
              class="delete icon-thrash border_grey_dark font-22 pointer"
            ></div>
            <!-- SEPERATOR LINE -->
            <div class="seperator-line"></div>
            <!-- BUTTON -->
            <button
              @click.prevent="saveChanges"
              ref="saveChangesBtn"
              :disabled="isDisabled"
              class="btn btn-sm font-10 px-3 btn-accent brand_navy"
            >
              <div
                v-if="isSaving"
                class="icon-dotted-roller font-17 mr-2 animate"
              ></div>
              {{ isSaving ? "Saving.." : "Save Changes" }}
            </button>
          </div>
        </div>
        <!-- BOTTOM -->
      </div>
    </div>

    <!-- MINIM STYLING -->
    <!-- LOOP THROUGH ALL ATTACHED QUESTIONS -->
    <div
      class="question-accordion-section rounded-5 w-100 overflow-hidden"
      :key="index"
      v-for="(item, index) in remaining_questions"
    >
      <div
        class="minim w-100 d-flex justify-content-between align-items-start nowrap"
      >
        <div
          class="left-side d-flex justify-content-start align-items-start nowrap"
        >
          <div class="icon icon-caret-down brand_black font-14"></div>

          <div class="question-info">
            <div
              class="question color_text"
              v-html="getQuestionText(item.question)"
            ></div>
            <div class="info color_grey_dark">
              <span
                class="font-weight-bold text-uppercase"
                :class="setTypeColor(item.difficulty)"
                >{{ item.difficulty }}</span
              >
              • Duration: {{ item.duration }}s
            </div>
          </div>
        </div>
        <div class="right-side">
          <div class="avatar border pointer" @click="updateView(index)">
            <span
              class="icon-edit-pen border_grey_dark flex-center font-18"
            ></span>
          </div>
        </div>
      </div>
    </div>

    <ResponseDialog
      v-if="response_dialog"
      :alert_msg="alert_card_msg"
      :alert_type="alert_card_type"
      @closeAlert="toggleResponseDialog"
    ></ResponseDialog>

    <script
      type="application/javascript"
      defer
      async="true"
      src="https://www.wiris.net/demo/plugins/app/WIRISplugins.js?viewer=image"
    ></script>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { persistToLocal, purgeFromLocal } from "@/scripts/utilities";
import TextEditor from "@/components/classComps/assessment/TextEditor";
import OptionsBlock from "@/components/classComps/assessment/OptionsBlock";
import SearchSelect from "@/components/globalComps/SearchSelect";

export default {
  name: "QuestionAccordion",

  components: {
    TextEditor,
    OptionsBlock,
    SearchSelect,
    ResponseDialog: () =>
      import(
        /* webpackChunkName: "ResponseDialog" */ "@/components/globalComps/ResponseDialog"
      ),
  },

  props: {
    question: Object,
    questions: Array,
    topic_list: Array,
    add_question: Boolean,
    accordion_type: {
      type: String,
      default: "",
      // default: "maxim",
    },
  },

  computed: {
    // Disables the create button until it has the required contents
    isDisabled: {
      set: () => {},

      get: function() {
        if (this.action === "create") {
          switch (this.new_question.option_type) {
            case "true_false":
              return (
                this.new_question.question == "" ||
                this.new_question.duration == "" ||
                this.new_question.topic_id == "" ||
                this.new_question.answer == ""
              );
            case "multichoice":
              return (
                this.new_question.question == "" ||
                this.new_question.duration == "" ||
                this.new_question.topic_id == "" ||
                this.new_question.answer == "" ||
                this.new_question.option_a == "" ||
                this.new_question.option_b == "" ||
                this.new_question.option_c == "" ||
                this.new_question.option_d == ""
              );
            default:
              return (
                this.new_question.question == "" ||
                this.new_question.duration == "" ||
                this.new_question.topic_id == ""
              );
          }
        } else {
          switch (this.update_question.option_type) {
            case "true_false":
              return (
                this.update_question.question == "" ||
                this.update_question.duration == "" ||
                this.update_question.topic_id == ""
              );
            case "multichoice":
              // isSaving
              console.log(
                this.update_question.question == "" ||
                  this.update_question.duration == "" ||
                  this.update_question.topic_id == "" ||
                  this.update_question.option_a == "" ||
                  this.update_question.option_b == "" ||
                  this.update_question.option_c == "" ||
                  this.update_question.option_d == ""
              );
              return (
                this.update_question.question == "" ||
                this.update_question.duration == "" ||
                this.update_question.topic_id == "" ||
                this.update_question.option_a == "" ||
                this.update_question.option_b == "" ||
                this.update_question.option_c == "" ||
                this.update_question.option_d == ""
              );
            default:
              return (
                this.update_question.question == "" ||
                this.update_question.duration == "" ||
                this.update_question.topic_id == ""
              );
          }
        }
      },
    },
  },

  watch: {
    topic_list: "updateTopics",
    option_type: "updateEditor",
    // question_status: "setStatusColor",

    topic_id(val) {
      this.new_question.topic_id = val;
    },

    questions(val) {
      this.remaining_questions = val.filter(
        (item, index) => index != this.question_index
      );
    },

    "new_question.difficulty": {
      handler(value) {
        if (value === "easy") this.new_question.duration = 60;
        else if (value === "medium") this.new_question.duration = 70;
        else if (value === "hard") this.new_question.duration = 80;
      },
    },

    "update_question.difficulty": {
      handler(value) {
        if (value === "easy") this.update_question.duration = 60;
        else if (value === "medium") this.update_question.duration = 70;
        else if (value === "hard") this.update_question.duration = 80;
      },
    },
  },

  data() {
    return {
      status_color: "brand_navy",
      question_image: null,
      image_uploaded: null,

      basic_type: true,
      selected_topics: [],
      // question: {},
      update_question: {},
      update_topic_data: {},

      remaining_questions: [],
      question_id: "",
      new_question: {
        view: "maxim",
        question: "",
        option_a: "",
        option_b: "",
        option_c: "",
        option_d: "",
        option_e: "",
        answer: "",
        unique_question_identifier: "",
        duration: 60,
        score: 1,
        difficulty: "easy",
        type: "maxim",
        option_type: "true_false",
        topic_id: "",
        image: "",
      },
      answer: "",
      action: "create",
      topic_id: "",
      isCreating: false,
      isSaving: false,
      account_type: "",
      questions_link: "",
      current_homework: this.$parent.getCurrentlySelectHomework,
      question_type: "",
      question_data: "",

      clear_options: false,
      clear_selection: false,

      alert_card_msg: "",
      alert_card_type: "",
      response_dialog: false,
    };
  },

  mounted() {
    this.action = this.$route.query.action || "create";

    if (this.action === "edit") {
      this.isDisabled = true;
      this.question_id = this.$route.query.id;
      if (!this.question_id) {
        this.$router.push({
          name: this.questions_link,
        });
        return;
      }
      setTimeout(() => this.setCurrentQuestion(this.question_id), 2000);
    }
    this.unique_question_identifier = `questions_${this.current_homework.id}`;
  },

  methods: {
    ...mapActions([
      "createQuestion",
      "getQuestionDetails",
      "updateQuestion",
      "removeQuestionFromHomework",
      "uploadToBucket",
    ]),

    toggleResponseDialog() {
      this.response_dialog = !this.response_dialog;
    },

    getQuestionText(value) {
      return value.replace("<br />", "");
    },

    getAccountType() {
      this.account_type = this.$route.path.split("/")[1];

      if (this.account_type === "school")
        this.questions_link = "ManageSchoolAssessment";
      else if (this.account_type === "teacher")
        this.questions_link = "ManageTeacherAssessment";
    },

    setTypeColor(difficulty) {
      return difficulty === "easy"
        ? "brand_navy"
        : difficulty === "medium"
        ? "brand_accent"
        : "brand_tonic";
    },

    emptyTopicSelection() {
      this.clear_selection = true;
      this.new_question.topic_id = "";
    },

    clearQuestionContent() {
      this.new_question = {
        view: "maxim",
        question: "",
        option_a: "",
        option_b: "",
        option_c: "",
        option_d: "",
        option_e: "",
        answer: "",
        duration: 30,
        score: 2,
        difficulty: "easy",
        type: "maxim",
        option_type: "true_false",
        topic_id: "",
        image: "",
      };

      this.question_image = "";
      this.updateQuestionInput(" ");
      this.questionInput(" ");

      this.clear_options = true;
      this.clear_selection = true;
    },

    updateTopic($event) {
      this.new_question.topic_id = $event.selection.id;
      this.clear_selection = $event.clear;
    },

    updateView(index) {
      this.action = "edit";
      let question = this.remaining_questions[index];
      this.setCurrentQuestion(question.id);
    },

    getAnswer(ans) {
      this.clear_options = ans.clear;
      // console.log(ans);
      if (this.action === "create") this.new_question.answer = ans.value;
      else this.update_question.answer = ans.value;
      console.log("Update answer", this.update_question.answer);
    },

    getAnswerContent(ans) {
      let option = ans.answer.toLowerCase();
      switch (option) {
        case "a":
          this.new_question.option_a = ans.content;
          break;

        case "b":
          this.new_question.option_b = ans.content;
          break;

        case "c":
          this.new_question.option_c = ans.content;
          break;

        case "d":
          this.new_question.option_d = ans.content;
          break;

        case "e":
          this.new_question.option_e = ans.content;
          break;
      }
    },

    getUpdateAnswerContent(ans) {
      let option = ans.answer.toLowerCase();
      switch (option) {
        case "a":
          this.update_question.option_a = ans.content;
          break;

        case "b":
          this.update_question.option_b = ans.content;
          break;

        case "c":
          this.update_question.option_c = ans.content;
          break;

        case "d":
          this.update_question.option_d = ans.content;
          break;

        case "e":
          this.update_question.option_e = ans.content;
          break;
      }
    },

    updateCurrentQuestionInRoute(question_id) {
      history.pushState({}, null, `?action=edit&id=${question_id}`);
    },

    setCurrentQuestion(question_id) {
      let question_index = null;
      try {
        this.remaining_questions = this.questions.filter((item, index) => {
          if (item.id != question_id) return item;
          else question_index = index;
        });

        this.fetchQuestionDetails(question_id, question_index);
      } catch (err) {
        this.isDisabled = true;
        console.log(err);
      }
    },

    fetchQuestionDetails(question_id, index) {
      this.getQuestionDetails(question_id)
        .then((res) => {
          if (res.code === 200) {
            let question = res.data;
            console.log("Question", question);

            question.option_type = this.getQuestionType(question.type);
            this.update_question = question;
            this.update_topic_data = {
              id: question.topic_id,
              name: question.topic,
            };

            this.update_question.question_index = index;
            this.update_question.accordion_type = "maxim";
            this.selected_topics[0] = {
              topic_id: res.data.topic_id,
              topic: res.data.topic,
            };

            this.updateCurrentQuestionInRoute(question.id);
          } else if (res.code === 406) {
            this.showAlert(res.data.question_id[0]);
          } else {
            this.showAlert(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
          this.showAlert(err);
        });
    },

    async saveChanges() {
      this.isSaving = true;
      let homework = this.current_homework;

      let data;
      // type;
      if (this.update_question.option_type == "true_false") {
        console.log(this.update_question.answer);

        data = {
          question: this.update_question.question,
          difficulty: this.update_question.difficulty,
          answer: this.update_question.answer ? 1 : 0,
          class_id: Number(homework.class_id),
          subject_id: Number(homework.subject_id),
          topic_id: this.topic_id || this.update_question.topic_id,
          duration: this.update_question.duration,
          homework_id: homework.id,
        };

        console.log(data.answer);

        if (this.image_uploaded) {
          data.image = this.update_question.image = this.image_uploaded;
          // data.image = this.update_question.image;

          if (!data.image) {
            this.showAlert(
              "Unable to create question because the image was not uploaded, please try again."
            );
            return;
          }
        }
      } else if (this.update_question.option_type == "multichoice") {
        data = {
          homework_id: homework.id,
          option_a: this.update_question.option_a,
          option_b: this.update_question.option_b,
          option_c: this.update_question.option_c,
          option_d: this.update_question.option_d,
          question: this.update_question.question,
          difficulty: this.update_question.difficulty,
          answer: this.update_question.answer,
          class_id: Number(homework.class_id),
          subject_id: Number(homework.subject_id),
          topic_id: this.topic_id || this.update_question.topic_id,
          duration: this.update_question.duration,
        };

        if (this.image_uploaded) {
          data.image = this.update_question.image = this.image_uploaded;

          if (!data.image) {
            this.showAlert(
              "Unable to create question because the image was not uploaded, please try again."
            );
            return;
          }
        }
      } else if (
        this.update_question.option_type == "essay" ||
        this.update_question.option_type == "blank"
      ) {
        data = {
          homework_id: homework.id,
          question: this.update_question.question,
          difficulty: this.update_question.difficulty,
          class_id: Number(homework.class_id),
          subject_id: Number(homework.subject_id),
          topic_id: this.topic_id || this.update_question.topic_id,
          duration: this.update_question.duration,
        };
      }

      let actionData = null,
        Action = null;

      if (this.update_question.owner === "1") {
        Action = this.updateQuestion;
        actionData = {
          id: this.update_question.id,
          data,
        };
      } else {
        Action = this.createQuestion;
        actionData = {
          type: this.getQuestionType(this.update_question.type, "api"),
          data,
        };
      }

      await Action(actionData)
        .then((res) => {
          this.isSaving = false;
          if (res.code === 200) {
            if (this.update_question.owner === "1") {
              // Persist question_id to localStorage
              let action = persistToLocal(
                this.unique_question_identifier,
                res.data.id,
                true
              );
              if (action.status) {
                this.$parent.total_question_count = action.length;
              } else {
                this.$parent.total_question_count = action.length;
              }
            }

            this.showAlert(res.message, "success");
            // update question in question_index
            if (actionData.type === undefined) {
              // this is an update
              this.update_question.accordion_type = "minim";
              this.remaining_questions[
                this.update_question.question_index
              ] = this.update_question;
              this.update_question = {};
              this.selected_topics = [];
              // this.action = '';
              this.updateQuestionInput(""); // set content of question as null
              this.action = "create";
              this.$router.push({
                name:
                  this.account_type === "school"
                    ? "SchoolCreateQuestion"
                    : "TeacherCreateQuestion",
                query: { action: "create" },
              });
            } else {
              let recent_question = res.data;
              recent_question.type = "minim"; // view type
              recent_question.option_type = this.getQuestionType(res.data.type);

              // remove the old question from attached homework.
              this.removeQuestion(this.update_question.id, homework.id);

              // Remove from localStorage and append this new id
              let action = purgeFromLocal(
                this.unique_question_identifier,
                homework.id,
                true
              );
              if (action.status)
                this.$parent.total_question_count = action.length;
              else this.$parent.total_question_count = action.length;

              // console.log(this.update_question.question_index);
              this.remaining_questions.splice(
                this.update_question.question_index,
                1
              );
              this.$parent.assessment_questions.splice(
                this.update_question.question_index,
                1
              );
              // console.log(this.remaining_questions.splice(this.update_question.question_index, 1).length)

              // Push newly updated into Array or reload page and fetch question
              this.remaining_questions.unshift(recent_question);
              this.$parent.assessment_questions.unshift(res.data);

              // this.updateCurrentQuestionInRoute(recent_question.id);
              this.update_question = {};
              this.selected_topics = [];
              this.question_image = "";
              // this.$router.push({name : this.account_type === "school" ? 'SchoolCreateQuestion' : 'TeacherCreateQuestion'});
            }
          } else {
            this.showAlert(res.message);
          }

          this.isSaving = false;
          this.clearQuestionContent();
        })
        .catch((err) => {
          this.isSaving = false;
          console.log(err);
          this.showAlert(err);
        });
    },

    createNewQuestionData() {
      this.isCreating = true;
      let homework = this.current_homework;

      if (this.new_question.option_type == "true_false") {
        this.question_type = "bool";
        this.question_data = {
          question: this.new_question.question,
          difficulty: this.new_question.difficulty,
          answer:
            this.new_question.answer == true ||
            this.new_question.answer == "true"
              ? 1
              : 0,
          class_id: Number(homework.class_id),
          subject_id: Number(homework.subject_id),
          topic_id: this.new_question.topic_id,
          duration: this.new_question.duration,
          homework_id: homework.id,
        };

        // console.log("response", this.question_data);
        if (this.question_image) {
          this.question_data.image = this.image_uploaded;

          if (!this.question_data.image) {
            this.showAlert(
              "Unable to create question because the image was not uploaded, please try again."
            );
            return;
          }
        }

        setTimeout(() => {
          this.callCreateQuestion(this.question_type, this.question_data);
        }, 1500);
      }

      // MULTI CHOICE QUESTION
      else if (this.new_question.option_type == "multichoice") {
        // console.log("Multichoice seen");
        this.question_type = "multiple";
        this.question_data = {
          homework_id: homework.id,
          option_a: this.new_question.option_a,
          option_b: this.new_question.option_b,
          option_c: this.new_question.option_c,
          option_d: this.new_question.option_d,
          question: this.new_question.question,
          difficulty: this.new_question.difficulty,
          answer: this.new_question.answer,
          class_id: Number(homework.class_id),
          subject_id: Number(homework.subject_id),
          topic_id: this.topic_id || this.new_question.topic_id,
          duration: this.new_question.duration,
        };

        // console.log(this.question_data);

        if (this.question_image) {
          this.question_data.image = this.image_uploaded;

          if (!this.question_data.image) {
            this.showAlert(
              "Unable to create question because the image was not uploaded, please try again."
            );
            return;
          }
        }

        setTimeout(() => {
          this.callCreateQuestion(this.question_type, this.question_data);
        }, 1500);
      }
      // ESSAY QUESTION
      else if (
        this.new_question.option_type == "essay" ||
        this.new_question.option_type == "blank"
      ) {
        this.question_type = "essay";
        this.question_data = {
          homework_id: homework.id,
          question: this.new_question.question,
          difficulty: this.new_question.difficulty,
          class_id: Number(homework.class_id),
          subject_id: Number(homework.subject_id),
          topic_id: this.topic_id || this.new_question.topic_id,
          duration: this.new_question.duration,
        };

        // this.callCreateQuestion(this.question_type, this.question_data);
      }
    },

    async callCreateQuestion(question_type, question_data) {
      this.createQuestion({
        question_type,
        question_data,
      })
        .then((res) => {
          console.log("Create question", res);
          if (res.code === 200) {
            // Also add question id to localstorage
            let action = persistToLocal(
              this.unique_question_identifier,
              res.data.id,
              true
            );

            if (action.status) this.total_question_count = action.length;
            else this.total_question_count = action.length;

            this.showAlert("Question created succesfully", "success");
            let recent_question = res.data;
            recent_question.type = "minim"; // view type
            recent_question.option_type = this.getQuestionType(res.data.type);

            // Push new question into Array or reload page and fetch question
            this.remaining_questions.unshift(recent_question);
            this.$parent.assessment_questions.unshift(res.data);
            this.selected_topics = [];

            this.clearQuestionContent();
            this.question_image = null;
          } else this.showAlert(res.message);

          this.isCreating = false;

          this.new_question = {
            view: "maxim",
            question: "",
            option_a: "",
            option_b: "",
            option_c: "",
            option_d: "",
            option_e: "",
            answer: "",
            duration: 30,
            score: 2,
            difficulty: "easy",
            type: "maxim",
            topic_id: "",
            image: "",
          };

          this.updateQuestionInput(" ");
          this.questionInput(" ");
          this.clearQuestionContent();
          localStorage.setItem("content", true);
        })
        .catch((err) => {
          this.isCreating = false;
          console.log(err);
          this.showAlert(err);
        });
    },

    getQuestionType(type, in_use = "view") {
      switch (type) {
        case "bool":
          return in_use == "view" ? "true_false" : "bool";

        case "multiple":
          return in_use == "view" ? "multichoice" : "multiple";

        default:
          return type;
      }
    },

    updateEditor() {
      this.option_type === "essay"
        ? (this.basic_type = false)
        : (this.basic_type = true);
    },

    updateTopics() {
      this.selected_topics = this.topic_list;
      this.topic_id = this.selected_topics[0].topic_id;
    },

    removeTopic(index) {
      this.selected_topics = this.selected_topics.filter(
        (topic, i) => index !== i
      );
    },

    uploadImage($event) {
      let file = $event.target.files[0];

      // GET FILE TYPE
      let valid_types = ["png", "jpg", "jpeg"];
      let file_type = file.type.split("/")[1];

      if (valid_types.indexOf(file_type) !== -1) {
        let reader = new FileReader();
        reader.onload = (evt) => {
          fetch(evt.target.result)
            .then((res) => res.blob())
            .then((blob) => {
              const new_file = new File([blob], file.name, {
                type: "image/png",
              });

              this.question_image = evt.target.result;
              this.question_image_to_upload = new_file;
              this.processImage(new_file);
            });
        };
        reader.readAsDataURL(file);
      }
    },

    // SEND A FILE TO S3 BUCKET LIST
    processImage(file) {
      let file_data = {
        folder: "files/questions",
        file,
        base64: false,
      };

      // PUSH TO BUCKET LIST
      this.uploadToBucket(file_data)
        .then((response) => {
          if (response.code === 200) {
            console.log(response);
            this.image_uploaded = response.data.ObjectURL;
          }
        })
        .catch((err) => console.log(err));
    },

    emptyImage() {
      this.update_question.image = this.new_question.image = this.question_image_to_upload = this.question_image =
        "";
    },

    questionInput(val) {
      if (this.action === "edit") this.update_question.question = val;
      else this.new_question.question = val;
    },

    updateQuestionInput(val) {
      this.update_question.question = val;
    },

    showAlert(msg, type = "error") {
      this.alert_card_msg = msg;
      this.alert_card_type = type;
      this.toggleResponseDialog();
    },

    removeQuestion(question_id, homework_id) {
      this.removeQuestionFromHomework({
        question_id,
        homework_id,
      })
        .then(() => {})
        .catch((err) => {
          console.log(err);
        });
    },

    fetchCloudinaryService() {
      this.getCloudinaryService()
        .then((response) => {
          if (response.code === 200) {
            this.cloudinary_data.cloudinary_base_api =
              response.data.cloudinary_base_api;
            this.cloudinary_data.preset = response.data.preset;
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style lang="scss">
.question-accordion-section {
  position: relative;
  background: #fff;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);
  margin-bottom: 5px;

  .maxim {
    .top {
      padding: 20px 34px;

      @include breakpoint_max(md) {
        padding: 20px 20px;
      }

      @include breakpoint_max(sm) {
        padding: 12px;
      }

      @include breakpoint_max(xs) {
        padding: 10px;
      }

      .selection-row {
        border-bottom: 1px solid $border_grey;
        padding-bottom: 20px;
        margin-bottom: 20px;

        @include breakpoint_max(xs) {
          padding-bottom: 10px;
        }
      }

      .question-entry {
        margin-bottom: 20px;

        .title-text {
          font-size: 14px;
          line-height: 19px;
          margin-bottom: 11px;

          @include breakpoint_max(md) {
            font-size: 13.5px;
          }

          @include breakpoint_max(sm) {
            font-size: 11.5px;
          }

          @include breakpoint_max(xs) {
            font-size: 11px;
          }
        }
      }

      .topic-cta {
        border: 1px solid red;
        padding: 11px 21px;
        width: 260px;
        margin-bottom: 11px;
        border: 1px solid $brand_tonic;
        background: $brand_red_light;
        @include flex_row_center_nowrap;
        transition: all 0.3s ease-in-out;

        @include breakpoint_max(sm) {
          padding: 9px 18px;
          width: 205px;
        }

        &:hover {
          transform: scale(0.98);
          box-shadow: 1px 2.5px 5px rgba(0, 0, 0, 0.15);
        }

        .text {
          margin-left: 13px;
          font-size: 13px;
          line-height: 19px;
          transition: all 0.4s ease-in-out;

          @include breakpoint_max(sm) {
            font-size: 11px;
          }
        }
      }

      .clear-btn {
        font-size: 10.75px !important;
        padding: 12px 30px !important;

        @include breakpoint_max(xs) {
          font-size: 9.5px !important;
          padding: 11px 21px !important;
        }
      }

      .topic-row {
        .topic-holder {
          font-size: 11.8px;
          line-height: 16px;
          padding: 7.5px 15.5px;
          margin-right: 10px;
          margin-bottom: 10px;

          @include breakpoint_max(sm) {
            font-size: 11px;
            line-height: 14px;
            padding: 6px 14px;
          }

          .avatar {
            margin-left: 12px;
            @include equal_min_edge(24);

            @include breakpoint_max(sm) {
              @include equal_min_edge(20);
            }
          }
        }
      }

      .image-section {
        margin-top: 25px;
        width: 260px;
        height: 170px;
        border: 1px solid $border_grey;
        background: $color_white;

        @include breakpoint_max(xs) {
          width: 100%;
          height: auto;
        }

        .avatar {
          @include equal_min_edge(24);
          top: -6px;
          right: -6px;
          z-index: 1;
          transition: all 0.3s ease-in-out;

          &:hover {
            background: $brand_tonic !important;
          }
        }

        img {
          @include img_cover;

          @include breakpoint_max(xs) {
            position: relative;
            width: 100%;
            height: auto;
          }
        }
      }
    }

    .bottom {
      @include flex_row_between_nowrap;
      background: $color_white;
      padding: 6px 30px;

      @include breakpoint_max(md) {
        padding: 5px 20px;
      }

      @include breakpoint_max(sm) {
        padding: 5px 12px;
      }

      @include breakpoint_max(xs) {
        padding: 2px 7px;
      }

      .button-left {
        .attachment {
          @include flex_row_start_nowrap;

          .attach {
            transition: all 0.3s ease-in-out;
          }

          @include breakpoint_max(md) {
            .icon {
              font-size: 18px !important;
              margin-top: 5px;
            }

            .text {
              font-size: 12.5px !important;
            }
          }

          @include breakpoint_max(sm) {
            .icon {
              font-size: 16px !important;
            }

            .text {
              font-size: 12px !important;
            }
          }

          @include breakpoint_max(xs) {
            .icon {
              font-size: 14.5px !important;
              margin-top: 3px;
            }

            .text {
              font-size: 11.5px !important;
            }
          }

          &:hover {
            .attach {
              color: darken($brand_accent, 8%) !important;
            }
          }
        }
      }

      .button-right {
        @include flex_row_end_nowrap;

        .delete {
          transition: all 0.3s ease-in-out;

          @include breakpoint_max(md) {
            font-size: 18px !important;
          }

          @include breakpoint_max(xs) {
            font-size: 15.5px !important;
          }

          &:hover {
            color: $brand_tonic !important;
          }
        }

        .seperator-line {
          height: 25px;
          width: 1px;
          background: $border_grey;
          margin: 0 7px 10px 10px;
        }

        .btn {
          @include breakpoint_max(xs) {
            font-size: 9px !important;
            padding: 10px 25px !important;
          }
        }
      }
    }
  }

  .minim {
    padding: 14px 25px;

    @include breakpoint_max(sm) {
      padding: 12px 18px;
    }

    @include breakpoint_max(xs) {
      padding: 12px 11px;
    }

    .left-side {
      margin-right: 50px;

      @include breakpoint_max(sm) {
        margin-right: 10px;
      }

      @include breakpoint_max(xs) {
        margin-right: 8px;
      }

      .icon {
        margin-right: 20px;

        @include breakpoint_max(md) {
          font-size: 15px !important;
        }

        @include breakpoint_max(sm) {
          margin-right: 10px;
          font-size: 13px !important;
        }

        @include breakpoint_max(xs) {
          margin-right: 9px;
          font-size: 10px !important;
        }
      }

      .question {
        font-size: 15.5px;
        line-height: 22px;
        margin-bottom: 4px;

        @include breakpoint_max(md) {
          line-height: 21px;
          font-size: 14.5px !important;
        }

        @include breakpoint_max(sm) {
          font-size: 13.5px !important;
          line-height: 19px;
        }

        @include breakpoint_max(xs) {
          font-size: 12px !important;
          line-height: 18px;
        }
      }

      .info {
        font-size: 13px;
        line-height: 18px;

        @include breakpoint_max(md) {
          font-size: 12.5px !important;
        }

        @include breakpoint_max(xs) {
          font-size: 11px !important;
        }
      }
    }

    .right-side {
      .avatar {
        @include equal_min_edge(32);
        transition: all 0.4s ease-in-out;

        @include breakpoint_max(xs) {
          @include equal_min_edge(28);
        }

        span {
          transition: all 0.3s ease-in-out;

          @include breakpoint_max(xs) {
            font-size: 14px !important;
          }
        }

        &:hover {
          box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.15);

          span {
            color: $brand_inverse !important;
          }
        }
      }
    }
  }
}

.selection-input {
  @include flex_row_start_nowrap;
  border-radius: 5px;
  background: $color_white;
  padding: 0px 11px 0px 10px;
  width: auto;
  margin-right: 30px;
  margin-bottom: 5px;

  @include breakpoint_max(md) {
    margin-right: 10px;
    padding: 0px 10px 0px 9px;
  }

  @include breakpoint_max(sm) {
    margin-right: 5px;

    .icon-caret-down {
      font-size: 9.5px !important;
      position: relative;
      top: 2px;
    }
  }

  .key {
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    text-transform: uppercase;
    color: $color_grey_dark;

    @include breakpoint_max(md) {
      font-size: 10.5px;
    }

    @include breakpoint_max(sm) {
      font-size: 10px;
      line-height: 14px;
    }

    @include breakpoint_max(xs) {
      font-size: 9.5px;
      line-height: 12px;
    }
  }

  .line {
    height: 18px;
    width: 1px;
    background: $border_grey;
    margin: 0 5px 0 10px;

    @include breakpoint_max(xs) {
      height: 16px;
      margin: 0 3px 0 7px;
    }
  }

  .form-control {
    width: auto !important;
    padding: 0;
    padding-left: 5px;
    background: transparent !important;
    font-size: 12px;
    color: $color_text;
    border: 0px solid transparent;

    &:focus {
      border: 0px solid transparent;
    }

    @include breakpoint_max(md) {
      font-size: 11px;
    }

    @include breakpoint_max(xs) {
      padding-left: 2px;
      font-size: 10.75px;
    }
  }

  .select-md-box {
    width: 90px !important;

    @include breakpoint_max(md) {
      width: 80px !important;
    }

    @include breakpoint_max(xs) {
      width: 75px !important;
    }
  }

  .select-sm-box {
    width: 70px !important;

    @include breakpoint_max(xs) {
      width: 55px !important;
    }
  }

  .number-box {
    width: 50px !important;

    @include breakpoint_max(md) {
      width: 30px !important;
    }

    @include breakpoint_max(xs) {
      width: 20px !important;
    }
  }
}
</style>
